// extracted by mini-css-extract-plugin
module.exports = {"logo":"App_logo__2e3lL","logoText":"App_logoText__WtDrT"};